import { Backdrop, Box, styled } from '@mui/material';

export const TriggerContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isOpen'
})<{ isOpen?: boolean }>(({ theme, isOpen }) => ({
  display: 'contents',
  ...(isOpen && {
    zIndex: theme.zIndex.modal
  })
}));

export const StyledBackdrop = styled(Backdrop)(({ theme }) => ({
  zIndex: theme.zIndex.modal - 1,
  backgroundColor: 'rgba(0, 0, 0, 0.1)'
}));

export const PopoverContextBox = styled(Box)({
  position: 'relative',
  '&.subActions': {
    position: 'absolute',
    left: '100%',
    '&:not(.escaping-vertical)': {
      top: '-1px'
    },
    '&.escaping-vertical': {
      bottom: '-1px'
    },
    '&.escaping-horizontal': {
      left: 'unset',
      right: '100%'
    }
  }
});
